import { put, takeEvery } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { logisticsSyncChangesActionCreators } from '..';
import { IState } from '../../..';
import { httpService } from '../../../..';
import { IPagedResponse } from '../../../apiInterfaces';
import { executeApiRequest } from '../../../asyncUtils';
import { showFailedRequestDialog } from '../../../sagaUtils';
import { uiActionCreators } from '../../../ui';
import { ILogisticsSyncChange, ILogisticsSyncChangeFilters } from '../logisticsSyncChangesInterfaces';

function* fetchLogisticsSyncChangesSaga(action: ReturnType<typeof logisticsSyncChangesActionCreators.fetch>) {
  const filters = yield* select((state: IState) => state.logisticsSyncChanges.filters);
  yield put(uiActionCreators.toggleLoading('logisticsSyncChanges'));
  const response = yield* call(fetchChanges, filters);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsSyncChangesActionCreators.set(response.value));
  }

  yield put(uiActionCreators.toggleLoading('logisticsSyncChanges'));
}

export function* watchFetchLogisticsSyncChanges() {
  yield takeEvery(logisticsSyncChangesActionCreators.fetch.match, fetchLogisticsSyncChangesSaga);
}

async function fetchChanges({ searchTerm, page, take }: ILogisticsSyncChangeFilters) {
  const skip = page * take;
  return executeApiRequest<IPagedResponse<ILogisticsSyncChange>>(() =>
    httpService.get(`/Logistics/SyncChanges?searchTerm=${searchTerm}&skip=${skip}&take=${take}`)
  );
}
